module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/9-91eb490d4e49dd835cbe38c80ea5e6e5.jpg";